import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../domain/amplitude'

export type QualifyingDeviceComponentProps = {
  handleClick: () => void
}

export const SUPPORT_URL =
  'https://paceline.zendesk.com/hc/en-us/articles/360051402551-What-device-s-do-you-currently-support-'

export const ScreenOpendedEvent: ScreenTracking = {
  from_screen: 'apply',
  heading:
    'To get the most out of your Paceline Card, take note of the following:',
  screen: 'device',
  asset_id: SCREEN_ASSET_ID
}

export const ButtonProcessedEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'NEXT',
  screen: 'device'
}
